import React from 'react';
import { IconProps } from '../types';

export const ExplainerIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.6104 5.99995L21.0001 0.233765V11.7661L30.6104 5.99995ZM26.7231 5.99995L23.0001 8.23376V3.76615L26.7231 5.99995Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1324 2.74027C9.5138 2.74027 7.39102 4.86305 7.39102 7.48162C7.39102 10.1002 9.5138 12.223 12.1324 12.223C14.7509 12.223 16.8737 10.1002 16.8737 7.48162C16.8737 4.86305 14.7509 2.74027 12.1324 2.74027ZM9.39102 7.48162C9.39102 5.96762 10.6184 4.74027 12.1324 4.74027C13.6464 4.74027 14.8737 5.96762 14.8737 7.48162C14.8737 8.99562 13.6464 10.223 12.1324 10.223C10.6184 10.223 9.39102 8.99562 9.39102 7.48162Z"
            fill={color}
        />
        <path
            d="M6.79343 15.2114H17.4719L23.0884 19.7044C23.5276 20.0558 23.8191 20.5591 23.9052 21.115C23.9914 21.6708 23.8659 22.2387 23.5536 22.7066L21.1399 26.3279L19.4757 25.2187L21.8898 21.5968C21.9241 21.5453 21.9383 21.4823 21.9288 21.4212C21.9194 21.3601 21.8873 21.3048 21.8391 21.2661L18.1208 18.2917V31.1768H16.1208V17.2114H8.14395V31.1768H6.14395V18.2921L2.4263 21.2661C2.37804 21.3047 2.34595 21.3601 2.33648 21.4212C2.32701 21.4823 2.34081 21.5448 2.37515 21.5962L4.78958 25.2187L3.12536 26.3279L1.15938 23.3783C0.867449 22.9403 0.71167 22.4257 0.71167 21.8993V21.5393C0.71167 20.749 1.06218 19.9995 1.66864 19.4928L6.79343 15.2114Z"
            fill={color}
        />
    </svg>
);
